import PageLayout from 'pages/EditQuiz/PageLayout';
import PageProvider from 'pages/EditQuiz/PageProvider';

const EditQuizPage = () => (
    <PageProvider>
        <PageLayout />
    </PageProvider>
);

export default EditQuizPage;
